import * as React from 'react';

import { cn } from '../lib/utils';
import { useFieldControlAria } from './field-aria';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  (
    {
      className,
      type,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedBy,
      ...props
    },
    ref
  ) => {
    // WCAG 3.3.1 — inside a <Field>, inherit `aria-invalid` +
    // `aria-describedby` from the field's registered FieldDescription /
    // FieldError elements (explicit caller aria always wins; outside a Field
    // or on a clean field the markup is unchanged).
    const fieldAria = useFieldControlAria({ ariaInvalid, ariaDescribedBy });
    return (
      <input
        type={type}
        data-slot="input"
        aria-invalid={fieldAria['aria-invalid']}
        aria-describedby={fieldAria['aria-describedby']}
        className={cn(
          // Height/padding follow the density control tokens so the field
          // resizes across comfortable/compact/touch/wall from --space-base.
          'flex h-[var(--control-height-md)] w-full rounded-xl border border-input bg-surface-raised px-[var(--control-padding-x-md)] py-1.5 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 transition-colors',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
